









import { Component, Vue } from "vue-property-decorator";
import { deleteUser } from "@/services/users/usersService";

@Component
export default class UserDeleteModal extends Vue {
        // local state
        userToBeDeleted: string = "";
        isSaved: boolean = false;

        // methods
        handleEnter(e: KeyboardEvent) {
            if (e.key === "Enter") this.confirmDelete();
        }

        removeEvent() {
            window.removeEventListener("keydown", this.handleEnter);
            this.isSaved = false;
        }

        open(userId: string) {
            this.userToBeDeleted = userId;
            this.$bvModal.show("modal-deleteUser");
            window.addEventListener("keydown", this.handleEnter);
        }

        declineDelete() {
            this.$bvModal.hide("modal-deleteUser");
            this.userToBeDeleted = "";
        }

        confirmDelete() {
            if (this.isSaved) return;
            this.isSaved = true;
            deleteUser(this.userToBeDeleted).then(() => {
                this.$emit("reload");
                this.userToBeDeleted = "";
                this.$bvModal.hide("modal-deleteUser");
            });
        }
}
